import { render, staticRenderFns } from "./detailFundingAgencyTrainings.vue?vue&type=template&id=9b4561d4&scoped=true"
import script from "./detailFundingAgencyTrainings.vue?vue&type=script&lang=js"
export * from "./detailFundingAgencyTrainings.vue?vue&type=script&lang=js"
import style0 from "./detailFundingAgencyTrainings.vue?vue&type=style&index=0&id=9b4561d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4561d4",
  null
  
)

export default component.exports